import { useState } from "react";

import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { DirectoryEntityType } from "@/ContactDirectory/Api/medfar-contactdirectory/dist";
import { DirectoryPopupController } from "@/ContactDirectory/Components/DirectoryPopupController";
import { FaxDirectorySearchComponent } from "@/ContactDirectory/Components/Search/FaxDirectorySearchComponent";
import { FaxDirectorySearchResultItem } from "@/ContactDirectory/Components/Search/FaxDirectorySearchResultItem";
import { DirectoryHealthCareProvider } from "@/ContactDirectory/Models/DirectoryHealthCareProvider";

interface IFaxDirectoryExternalConsultantSearchProps {
    patientContactId: string;
    isValid: boolean;
    onHealthCareProviderSelect: (entity: DirectoryHealthCareProvider) => void;
}

export function FaxDirectoryExternalConsultantSearch(props: IFaxDirectoryExternalConsultantSearchProps): JSX.Element {
    const { getText } = useTranslation();
    const [isAddToDirectoryPopupOpen, setIsAddToDirectoryPopupOpen] = useState<boolean>(false);

    return (
        <>
            <div className="display-flex-with-space-between">
                <span>{`${getText("SearchLabel")} :`}</span>
                <a
                    onClick={() => setIsAddToDirectoryPopupOpen(true)}
                >
                    {getText("AddToDirectoryLabel")}
                </a>
            </div>
            {isAddToDirectoryPopupOpen && (
                <DirectoryPopupController
                    onSave={(entity: DirectoryHealthCareProvider) => {
                        props.onHealthCareProviderSelect(entity);
                        setIsAddToDirectoryPopupOpen(false);
                    }}
                    defaultType={DirectoryEntityType.HealthcareProvider}
                    onClose={() => setIsAddToDirectoryPopupOpen(false)}
                    editModel={null}
                    onEntityUseInstead={(entity: DirectoryHealthCareProvider) => {
                        props.onHealthCareProviderSelect(entity);
                        setIsAddToDirectoryPopupOpen(false);
                    }}
                    onModify={(entity: DirectoryHealthCareProvider) => {
                        props.onHealthCareProviderSelect(entity);
                        setIsAddToDirectoryPopupOpen(false);
                    }}
                />
            )}
            <FaxDirectorySearchComponent
                onItemSelected={(selection: FaxDirectorySearchResultItem) => {
                    props.onHealthCareProviderSelect(selection?.entity as DirectoryHealthCareProvider);
                }}
                entityTypes={[DirectoryEntityType.HealthcareProvider]}
                isValid={props.isValid}
                filterExternalConsultants
                dataCy="contactDirectory-externalConsultantSearch"
                allowExpandingGeographicSearch
            />
        </>
    );
}
